import "./KusumYojna.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Autoplay,EffectCoverflow  } from "swiper/modules";
import { useState } from "react";
import "swiper/css/effect-coverflow";

const projectData = [
    {
        image: "/kusumimg1.jpeg",
        title: "Jaipur",
        description: "19mw",
    },
    {
        image: "/kusumimg2.jpeg",
        title: "Jodhpur",
        description: "13mw",
    },
    {
        image: "/kusumimg3.jpeg",
        title: "Phalodi",
        description: "32.5mw",
    },
    {
        image: "/kusumimg4.jpeg",
        title: "Jaisalmer",
        description: "3.25mw",
    },
    {
        image: "/kusumimg5.jpeg",
        title: "Chittorgarh",
        description: "4mw",
    },
    {
        image: "/kusumimg6.jpeg",
        title: "Sikar",
        description: "7.2mw",
    },
];

const TestimonialSlider = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <section className="container py-5 text-center">
            <div className="row">
                <div className="col-lg-10 col-md-12 mx-auto">
                    <h2
                        className="TextRes mb-4 position-relative"
                        style={{ color: "black", textTransform: 'uppercase' }}
                    >
                        <span
                            style={{
                                fontSize: "55px",
                                position: "absolute",
                                top: "-15px",
                                left: "50%",
                                transform: "translateX(-50%)",
                                borderBottom: "2px solid #faab04",
                                width: "50px",
                            }}
                        ></span>
                        Completed Projects{" "}
                        <span style={{ color: "#a20000" }}>under PM KUSUM</span>
                    </h2>
                </div>
            </div>

            {/* <div className="row justify-content-center"> */}
                {/* <div className="col-12"> */}
                    {/* <Swiper
                        modules={[Autoplay]}
                        spaceBetween={24}
                        loop={true}
                        slidesPerView="auto"
                        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                        autoplay={{
                            delay: 3000,
                            disableOnInteraction: false,
                        }}
                        breakpoints={{
                            320: { slidesPerView: 1 },
                            640: { slidesPerView: 2 },
                            1024: { slidesPerView: 2 },
                            1280: { slidesPerView: 2 },
                        }}
                    >
                        {projectData.map((project, index) => (
                            <SwiperSlide key={index} style={{ width: "500px" }}>
                                <div className="position-relative overflow-hidden rounded shadow">
                                    <img
                                        src={project.image}
                                        alt={project.title}
                                        style={{
                                            objectFit: "cover",
                                            height: "400px",
                                            width: "100%",
                                            filter:index !== activeIndex?'brightness(40%)':''
                                        }}
                                    />
                                    {index === activeIndex && (
                                        <div
                                            className=" fade-in d-flex flex-column justify-content-center align-items-center text-white text-center px-3"
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                backgroundColor: "rgba(0, 0, 0, 0.18)",
                                            }}
                                        >
                                            <h5 className=" mb-2" style={{
                                                fontSize: "clamp(1.2rem, 10vw, 1.8rem)",
                                                color: "#A20000",
                                                textShadow: "2px 2px 6px rgba(0,0,0,0.7)",
                                                fontWeight: 700,
                                                textTransform:'uppercase'
                                            }}>
                                                {project.title}
                                            </h5>
                                            <p className="mb-0"
                                            style={{
                                                    fontSize: "clamp(0.9rem, 5vw, 1.2rem)",
                                                    maxWidth: "90%",
                                                    color: "#ffffff",
                                                    textShadow: "1px 1px 5px rgba(0,0,0,0.6)",
                                                    textTransform:'uppercase'
                                                }}
                                            >{project.description}</p>
                                        </div>
                                    )}
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper> */}
                    <Swiper
                        modules={[Autoplay, EffectCoverflow]}
                        effect="coverflow"
                        grabCursor={true}
                        centeredSlides={true}
                        loop={true}
                        slidesPerView="auto"
                        spaceBetween={0}
                        autoplay={{
                            delay: 2900,
                            disableOnInteraction: false,
                        }}
                        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                        coverflowEffect={{
                            rotate: 0,
                            stretch: 0,
                            depth: 100,
                            modifier: 2.2,
                            slideShadows: false,
                        }}
                        className="mySwiper rounded"
                    >
                        {projectData.map((project, index) => (
                            <SwiperSlide key={index} style={{ width: "400px" }}>
                                <div className="position-relative overflow-hidden rounded shadow">
                                    <img
                                        src={project.image}
                                        alt={project.title}
                                        style={{
                                            objectFit: "cover",
                                            height: "400px",
                                            width: "100%",
                                            filter: index !== activeIndex ? "brightness(40%)" : "",
                                            borderRadius: "10px",
                                        }}
                                    />
                                    {index === activeIndex && (
                                        <div
                                            className="fade-in d-flex flex-column justify-content-center align-items-center text-white text-center px-3"
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                backgroundColor: "rgba(0, 0, 0, 0.18)",
                                            }}
                                        >
                                            <h5
                                                className="mb-2"
                                                style={{
                                                    fontSize: "clamp(1.2rem, 10vw, 1.8rem)",
                                                    color: "#A20000",
                                                    textShadow: "2px 2px 6px rgba(0,0,0,0.7)",
                                                    fontWeight: 700,
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {project.title}
                                            </h5>
                                            <p
                                                className="mb-0"
                                                style={{
                                                    fontSize: "clamp(0.9rem, 5vw, 1.2rem)",
                                                    maxWidth: "90%",
                                                    color: "#ffffff",
                                                    textShadow: "1px 1px 5px rgba(0,0,0,0.6)",
                                                    textTransform: "uppercase",
                                                }}
                                            >
                                                {project.description}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                {/* </div> */}
            {/* </div> */}
        </section>
    );
};

export default TestimonialSlider;
